package com.example.mystybag.core.security

internal actual class SecurityHelper actual constructor() {
    actual fun encryptWithAppAESKey(data: ByteArray): String? = null
    actual fun decryptWithAppAESKey(data: String): ByteArray? = null
}
